// extracted by mini-css-extract-plugin
module.exports = {"theme":"#ffab11","theme2":"#fa9716","bg":"#F8F9FA","orange":"#fa5300"};